import type { RiskFactor } from '@/portfolio/proposal-builder/types'
import type { ModelConstraint } from '@/types/api/constraints'

/**
 * Visits every constraint a factor holds, across all of its slots: the
 * filter-list inclusion/exclusion/allocation slots plus each field's
 * universe / diversification / piecewise / average-value / allocation slots.
 */
export function eachConstraintInFactor(
  riskFactor: RiskFactor,
  visit: (constraint: ModelConstraint) => void,
): void {
  const filterListConstraints = riskFactor.filterListConstraints
  if (filterListConstraints) {
    if (filterListConstraints.inclusionConstraint) {
      visit(filterListConstraints.inclusionConstraint)
    }
    if (filterListConstraints.exclusionConstraint) {
      visit(filterListConstraints.exclusionConstraint)
    }
    for (const constraint of filterListConstraints.allocationConstraints) {
      visit(constraint)
    }
  }
  for (const fieldConstraints of Object.values(riskFactor.fields)) {
    if (!fieldConstraints) continue
    if (fieldConstraints.universeConstraint) {
      visit(fieldConstraints.universeConstraint)
    }
    if (fieldConstraints.diversificationConstraint) {
      visit(fieldConstraints.diversificationConstraint)
    }
    if (fieldConstraints.piecewiseDiversificationConstraint) {
      visit(fieldConstraints.piecewiseDiversificationConstraint)
    }
    if (fieldConstraints.averageValueConstraint) {
      visit(fieldConstraints.averageValueConstraint)
    }
    for (const constraint of fieldConstraints.allocationConstraints) {
      visit(constraint)
    }
  }
}
